import React from 'react'
import ConnectedComponent from '../../shared/connecter/ConnectedComponent'
import {GridList, GridTile} from 'material-ui/GridList';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert'
import IconButton from 'material-ui/IconButton'
import IconMenu from 'material-ui/IconMenu'
import CloseIcon from 'material-ui/svg-icons/navigation/close'
import MenuItem from 'material-ui/MenuItem'
import RaisedButton from 'material-ui/RaisedButton'
import Unique from '../../shared/utils/Unique'
import Paper from 'material-ui/Paper'
import FieldComponent from '../../shared/inputs/components/FieldComponent'
import FlatButton from 'material-ui/FlatButton'
import UserImagePlaceHolder from '../../assets/placeholder.user.png'


const styles = {
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
    },
    gridList: {
        width: '100%',
        height: 450,
        overflowY: 'auto',
    },
};


class EditPlayer extends ConnectedComponent {
    constructor() {
        super()
        this.state = {
            player: {}
        }
    }

    change = (prop, v) => {
        const {player} = this.state
        const d = {}
        d[prop] = v
        this.setState({
            player: Object.assign({}, player, d)
        })
    }
    deletePlayer = (playerId) => {
        this.store.playersHistory.remove(this.store.playersHistory.get(playerId))
        this.props.close()
    }
    save = () => {
        const {player} = this.state
        this.store.playersHistory.get(player.id).set(player)
        this.props.close()
    }

    componentWillMount() {
        this.setState({
            player: this.store.playersHistory.get(this.props.playerId).toJSON()
        })
    }

    componentWillUpdate(props, s) {
        if (this.props.playerId !== props.playerId) {
            this.setState({
                player: this.store.playersHistory.get(props.playerId).toJSON()
            })
        }
    }

    render() {
        const player = this.state.player
        const style = {width: '100%'}
        const inputStyle = {marginLeft: '20px'}
        const buttonStyle = {lineHeight: '30px', height: '30px'}
        return (
            <Paper className="animated fadeIn">
                <div>
                    <FieldComponent inputStyle={inputStyle} style={style} name={'name'} placeholder="Nom"
                                    onChange={v => this.change('name', v)} value={player.name}/>
                </div>
                <div>
                    <FieldComponent inputStyle={inputStyle} style={style} name={'image'} placeholder="Image"
                                    onChange={v => this.change('image', v)} value={player.image}/>
                </div>
                <div className="text-right" style={{padding: '0 20px 10px 20px'}}>
                    <FlatButton style={buttonStyle} label={'supprimer joueur'} icon={<CloseIcon />} secondary={true}
                                onClick={v => this.deletePlayer(player.id)}/>
                    <RaisedButton style={buttonStyle} label={'OK'} primary={true} onClick={v => this.save()}/>
                </div>
            </Paper>
        )
    }
}

class AddPlayerButton extends ConnectedComponent {

    addPlayer = () => {
        this.store.playersHistory.add({id: new Unique().gen(), name: 'Joueur'})
    }

    render() {
        return (
            <RaisedButton onClick={this.addPlayer} label="Ajouter Joueur" fullWidth={true}/>
        )
    }
}

const iconButtonElement = (
    <IconButton touch={true}>
        <MoreVertIcon color="#FFF" />
    </IconButton>
);

class DeleteMenuItem extends ConnectedComponent {
    deletePlayer = () => {
        const {id} = this.props.player
        this.store.playersHistory.remove(this.store.playersHistory.get(id))
    }

    render() {
        return <MenuItem onTouchTap={this.deletePlayer}>Supprimer</MenuItem>
    }
}

class EditMenuitem extends React.Component {
    edit = () => {
        const {id} = this.props.player
        this.props.editPlayer(id)
    }

    render() {
        return <MenuItem onTouchTap={this.edit}>Editer</MenuItem>
    }
}

const ops = {"horizontal": "right", "vertical": "top"}

class PlayerTile extends ConnectedComponent {
    onPickPlayer = () => {
        if (this.props.onPickPlayer) this.props.onPickPlayer(this.props.player)
    }
    render(){
        const {player} = this.props
        const rightIconMenu = (<IconMenu anchorOrigin={ops} targetOrigin={ops} iconButtonElement={iconButtonElement}>
            <EditMenuitem editPlayer={this.props.editPlayer} player={player}/>
            <DeleteMenuItem player={player}/>
        </IconMenu>)
        return (<GridTile key={player.name} title={player.name} actionIcon={rightIconMenu}>


            <img onTouchTap={this.onPickPlayer} src={player.image || UserImagePlaceHolder} alt={player.name} />
        </GridTile>)
    }
}

export default class PreviousPlayersComponent extends ConnectedComponent {
    constructor(){
        super()
        this.subscribe('playersHistory')
        this.state = {
            editing:null
        }
    }
    onPickPlayer = (player) => {
        if (this.props.onPickPlayer) this.props.onPickPlayer(player)
    }
    editPlayer = (id) => {
        console.log(id)
        this.setState({
            editing: this.state.editing === id ? null : id
        })
    }
    closeEditing = () => {
        this.setState({
            editing: null
        })
    }
    render() {
        const players = this.store.playersHistory.toJSON()
        const items = players.map((player) => <PlayerTile editPlayer={this.editPlayer} key={player.id} player={player} onPickPlayer={this.onPickPlayer} />)
        return (<div style={styles.root}>
                <GridList cellHeight={130} style={styles.gridList} cols={4}>
                    {items}
                </GridList>
            <div>
                {this.state.editing ? <EditPlayer close={this.closeEditing} playerId={this.state.editing}/> : null}
            </div>
                <AddPlayerButton />
            </div>)
    }
}


// WEBPACK FOOTER //
// ./src/game/players/PreviousPlayersComponent.jsx